// import React, { useEffect, useState } from 'react';
// import Cookies from 'js-cookie';
// import { useTranslation } from 'react-i18next';

// function ChangeLanguage() {
//   const apiUrl = process.env.REACT_APP_BACKEND_URL;
//   const userId = Cookies.get('userId');
//   const userToken = Cookies.get('UserSpecialToken');

//     const [Language,setLanguage] = useState('fr')
//     const { i18n } = useTranslation();
//     const [DropDown ,setDropDown] = useState(false)
//     const [Done ,setDone] = useState(false)


//     const UpdateLanguageData = (Language) => {
//       fetch(`${apiUrl}/UpdateLanguageData`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           Authorization: `Bearer ${userToken}`,
//         },
//         body: JSON.stringify({ language: Language}),
//       })
//         .then(response => response.json())
//         .then(result => {
//           if (result.success) {
//             setDone(!Done)
//             Cookies.set('LanguageSelected', result.message, { expires: 30 });
//             console.log(result.message);
//           }
//         });
//     };

//     useEffect(() => {
//       fetch(`${apiUrl}/GetLangugeProfileEdit`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           Authorization: `Bearer ${userToken}`,
//         },
//         body: JSON.stringify({ user_id: userId }),
//       })
//         .then(response => response.json())
//         .then(result => {
//           i18n.changeLanguage(result.data);
//           setLanguage(result.data)
//         });
//     }, [Done]);
  



//     const languages = [
//         {value : 'fr' , name: 'FR', flag: 'https://upload.wikimedia.org/wikipedia/en/thumb/c/c3/Flag_of_France.svg/1280px-Flag_of_France.svg.png' },
//         {value : 'en' ,  name: 'EN', flag: 'https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/1280px-Flag_of_the_United_States.svg.png' },
//         {value : 'ar' ,  name: 'AR', flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Arabic-Language-Flag.svg/800px-Arabic-Language-Flag.svg.png?20110729044451' },

//     ];

//     const remainLanguage = languages.filter(value => value.value != Language)
//     const selectedLanguage = languages.filter(value => value.value == Language)

//   return (
//     <div className='ltrDiv'>
//         <button className="absolute flex h-8 z-10 right-2 top-2 px-1 w-16 flex justify-start py-2 sections text-theme rounded-lg" onClick={(e) => {UpdateLanguageData(selectedLanguage[0].value);setDropDown(!DropDown)}}>
//                 <img src={selectedLanguage[0].flag}  className="w-4 h-4 mr-1 rounded-full" />
//                 <p className='-mt-1 font-semibold'>{selectedLanguage[0].name}</p>
//                 <div>
//                 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-3 h-3 ml-1 mt-0.5 text-bold">
//                 <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
//                  </svg>
//                 </div>
//         </button>

//         {DropDown &&
//         <div className='absolute z-10 right-2 top-10'>
//         <button className=" flex h-8  px-1 w-16 flex justify-start py-2 div-sections text-theme rounded-t-lg" onClick={(e) => {UpdateLanguageData(remainLanguage[0].value);setDropDown(false)}}>
//         <img src={remainLanguage[0].flag} className="w-4 h-4 mr-1 rounded-full" />
//         <p className='-mt-1 font-semibold'>{remainLanguage[0].name}</p>
//         </button>
//         <button className=" flex h-8  px-1 w-16 flex justify-start py-2 div-sections text-theme rounded-b-lg border-t-1 border-gray-400" onClick={(e) => {UpdateLanguageData(remainLanguage[1].value);setDropDown(false)}}>
//         <img src={remainLanguage[1].flag} className="w-4 h-4 mr-1 rounded-full" />
//         <p className='-mt-1 font-semibold'>{remainLanguage[1].name}</p>
        
//         </button>
//         </div>
       
//         }
       
      
        
//     </div>
    
//     )
// }

// export default ChangeLanguage
import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';

function ChangeLanguage() {
  const apiUrl = process.env.REACT_APP_BACKEND_URL;
  const userId = Cookies.get('userId');
  const userToken = Cookies.get('UserSpecialToken');
  const { i18n } = useTranslation();

  const [Language, setLanguage] = useState('fr');
  const [DropDown, setDropDown] = useState(false);
  const [Done, setDone] = useState(false);

  const languages = [
    { value: 'fr', name: 'FR', flag: 'https://upload.wikimedia.org/wikipedia/en/c/c3/Flag_of_France.svg' },
    { value: 'en', name: 'EN', flag: 'https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg' },
    { value: 'ar', name: 'AR', flag: 'https://upload.wikimedia.org/wikipedia/commons/0/0d/Flag_of_Saudi_Arabia.svg' },
  ];

  // 🧩 Unified update function
  const UpdateLanguageData = (lang) => {
    if (userId && userToken) {
      // 🔐 Logged-in user → update backend
      fetch(`${apiUrl}/UpdateLanguageData`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({ language: lang }),
      })
        .then(res => res.json())
        .then(result => {
          if (result.success) {
            Cookies.set('LanguageSelected', lang, { expires: 30 });
             setLanguage(lang);
            i18n.changeLanguage(lang);
            setDone(!Done);
             window.dispatchEvent(new CustomEvent('languageChanged', { detail: lang }));

          }
        });
    } else {
      // 👤 Normal user → just update cookie and i18n
      Cookies.set('LanguageSelected', lang, { expires: 30 });
      setLanguage(lang);
      i18n.changeLanguage(lang);
            window.dispatchEvent(new CustomEvent('languageChanged', { detail: lang }));

    }
  };

  // 📦 Load user language preference
  useEffect(() => {
    if (userId && userToken) {
      fetch(`${apiUrl}/GetLangugeProfileEdit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({ user_id: userId }),
      })
        .then(res => res.json())
        .then(result => {
          const lang = result?.data || 'fr';
          i18n.changeLanguage(lang);
          setLanguage(lang);
                    Cookies.set('LanguageSelected', lang, { expires: 30 });

        });
    } else {
      // Load from cookie for normal users
      const savedLang = Cookies.get('LanguageSelected') || 'fr';
      setLanguage(savedLang);
      i18n.changeLanguage(savedLang);
    }
  }, [Done]);

  const remainLanguage = languages.filter(v => v.value !== Language);
  const selectedLanguage = languages.find(v => v.value === Language);

  return (
    <div className='ltrDiv'>
      <button
        className="absolute flex h-8 z-10 right-2 top-2 px-1 w-16 justify-start py-2 sections text-theme rounded-lg"
        onClick={() => setDropDown(!DropDown)}
      >
        <img src={selectedLanguage.flag} className="w-4 h-4 mr-1 rounded-full" alt={selectedLanguage.name} />
        <p className='-mt-1 font-semibold'>{selectedLanguage.name}</p>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-3 h-3 ml-1 mt-0.5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
      </button>

      {DropDown && (
        <div className='absolute z-10 right-2 top-10'>
          {remainLanguage.map(lang => (
            <button
              key={lang.value}
              className="flex h-8 px-1 w-16 justify-start py-2 div-sections text-theme rounded-lg border-t border-gray-200"
              onClick={() => { UpdateLanguageData(lang.value); setDropDown(false); }}
            >
              <img src={lang.flag} className="w-4 h-4 mr-1 rounded-full" alt={lang.name} />
              <p className='-mt-1 font-semibold'>{lang.name}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default ChangeLanguage;
